import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@src/lib/utils";

export type InputProps = InputHTMLAttributes<HTMLInputElement>;
interface LabelProps extends InputProps {
  label?: string;
  labelClassName?: string;
  endAdornment?: JSX.Element;
  startAdornment?: JSX.Element;
}

const Input = forwardRef<HTMLInputElement, LabelProps>(
  (
    { className, type, label = "", endAdornment, labelClassName, ...props },
    ref,
  ) => {
    return (
      <div className={cn("w-full", className)}>
        <label className="relative block">
          <input
            className={cn(
              "customInput border-[rgba(39, 44, 69, 0.20)] focus:text-slate-900 text-textBlack peer block h-[56px] w-full appearance-none rounded-lg border bg-transparent px-4 py-2 font-normal focus:outline-none disabled:bg-gray-100",
              className,
            )}
            ref={ref}
            type={type}
            {...props}
            placeholder={props.placeholder || ""}
          />
          <div
            className={cn(
              "absolute left-2 top-[10px] z-10 origin-[0] -translate-y-2 transform cursor-text whitespace-nowrap px-2 text-xs text-gray-700 duration-150 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400",
              labelClassName,
              'customLabel',
            )}
          >
            {label}
          </div>
          <div className="pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3">
            {endAdornment}
          </div>
        </label>
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
